// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResearchInterestTags-cls1__c520aeab07e08aa0e2dd{/*!*/}.ResearchInterestTags-cls2___1df954c5e0a68ef5bce{display:flex;align-items:center;height:40px;width:100%;padding:0px 5px}.ResearchInterestTags-cls2___1df954c5e0a68ef5bce i{width:16px;height:16px;margin-right:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ResearchInterestTags-cls1__c520aeab07e08aa0e2dd",
	"cls2": "ResearchInterestTags-cls2___1df954c5e0a68ef5bce ResearchInterestTags-cls1__c520aeab07e08aa0e2dd"
};
export default ___CSS_LOADER_EXPORT___;
